import { render, staticRenderFns } from "./result-hover.vue?vue&type=template&id=06b2492b&scoped=true&"
import script from "./result-hover.vue?vue&type=script&lang=js&"
export * from "./result-hover.vue?vue&type=script&lang=js&"
import style0 from "./result-hover.vue?vue&type=style&index=0&id=06b2492b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2492b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout})
